module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-container', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('div', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Management Team")]), _vm._v(" "), _c('p', {
    staticClass: "static-info--sub-teaser"
  }, [_vm._v("Meat the team that bring you the best in cinema entertainment ")])])], 1), _vm._v(" "), _vm._l((_vm.people), function(person, index) {
    return _c('div', {
      key: index
    }, [(person.type === 'Management_Team') ? _c('div', [_c('sk-layout', {
      staticClass: "management__content",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "management__image"
    }, [_c('img', {
      attrs: {
        "src": person.image
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "md10": ""
      }
    }, [_c('h6', {
      staticClass: "management__person-name",
      domProps: {
        "innerHTML": _vm._s(person.name)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "management__job-description",
      domProps: {
        "innerHTML": _vm._s(person.position)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "management__summary"
    }, [_c('p', [_vm._v(_vm._s(person.description))])])])], 1), _vm._v(" "), _c('hr')], 1) : _vm._e()])
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-title-heading', {
    staticClass: "sharedolders-heading",
    attrs: {
      "h3": "",
      "no-border": "",
      "label": "Meet our Shareholders"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-button', {
    attrs: {
      "tag": "a",
      "secondary": "",
      "small": "",
      "href": "/"
    }
  }, [_vm._v("Read More")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.people), function(person, index) {
    return _c('sk-flex', {
      key: index,
      attrs: {
        "xs6": "",
        "md2": ""
      }
    }, [(person.type === 'Shareholder') ? _c('div', {
      staticClass: "shareholder"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": person.image
      }
    })]) : _vm._e()])
  }))], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d568e8a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/management-team/management-team.vue
// module id = 840
// module chunks = 0